var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3889 11.1289H20.3229C19.808 11.1289 19.3258 10.8738 19.0364 10.4476L16.8509 7.23534C16.5616 6.81067 16.0809 6.55556 15.566 6.55556H8.61111C6.89222 6.55556 5.5 7.94778 5.5 9.66667V28.3333C5.5 30.0522 6.89222 31.4444 8.61111 31.4444H30.3889C32.1078 31.4444 33.5 30.0522 33.5 28.3333V14.24C33.5 12.5227 32.1078 11.1289 30.3889 11.1289Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6846 16.7958V18.6127C17.6846 19.1136 18.0906 19.5196 18.5915 19.5196H20.4083C20.9092 19.5196 21.3152 19.1136 21.3152 18.6127V16.7958C21.3152 16.2949 20.9092 15.8889 20.4083 15.8889H18.5915C18.0906 15.8889 17.6846 16.2949 17.6846 16.7958Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2856 24.054V25.8709C13.2856 26.3718 13.6916 26.7778 14.1925 26.7778H16.0094C16.5103 26.7778 16.9163 26.3718 16.9163 25.8709V24.054C16.9163 23.5531 16.5103 23.1471 16.0094 23.1471H14.1925C13.6916 23.1487 13.2856 23.5531 13.2856 24.054V24.054Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0837 24.054V25.8709C22.0837 26.3718 22.4897 26.7778 22.9906 26.7778H24.8075C25.3084 26.7778 25.7144 26.3718 25.7144 25.8709V24.054C25.7144 23.5531 25.3084 23.1471 24.8075 23.1471H22.9906C22.4897 23.1487 22.0837 23.5531 22.0837 24.054V24.054Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0822 24.5222H16.9177",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0623 23.1533L18.5045 19.4978",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6355 19.4667L22.9688 23.1533",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPdf);
export default __webpack_public_path__ + "static/media/folder-Pdf.bf55a77f10efef2a9530beaf11e1f634.svg";
export { ForwardRef as ReactComponent };